import { fetchDataByTag as fetchDataByTagApi } from 'support/api/DataByTagApi';
import { HttpClient } from 'support/api/api-types';

export const SHOW = 'SHOW' as const;
export const CLEAR_SHOW = 'CLEAR_SHOW' as const;

export const fetchShow = (tag: string) => ({
  type: SHOW,
  promise: (httpClient: HttpClient) => fetchDataByTagApi(httpClient, tag),
  meta: {
    id: tag,
  },
});

export const clearShow = () => ({
  type: CLEAR_SHOW,
});
